import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=52eee2b5&scoped=true&"
import script from "./ModalAlert.vue?vue&type=script&lang=ts&"
export * from "./ModalAlert.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAlert.vue?vue&type=style&index=0&id=52eee2b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eee2b5",
  null
  
)

export default component.exports